import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { Navigation, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { promiseWithCatch, unsubscribeAll } from 'src/app/common/app.helpers';
import { MaybeNull } from 'src/app/utils';
import { OperationInfoService } from '../../common/long-operations/operation-info.service';
import ProjectLinks from '../../common/project.links';
import { SecondAuthLevelService } from '../second-auth-level.service';

@Component({
  selector: 'app-bind-authenticator',
  templateUrl: './bind-authenticator.component.html',
  styleUrls: ['./bind-authenticator.component.scss'],
  providers: [],
})
export class BindAuthenticatorComponent implements OnInit, OnDestroy {
  public previousPage: string;

  public authenticatorSecret: string;
  public authenticatorSecretPart: string;
  public email: string;
  public bindAuthenticator: boolean;

  private subscriptions$: Subscription[] = [];

  private router = inject(Router);
  private secondAuthLvlService = inject(SecondAuthLevelService);
  private operationInfoService = inject(OperationInfoService);

  public constructor() {
    this.parseNavigationExtras();
  }

  public ngOnInit(): void {
    this.subscribeToAuthenticatorSecretChanges();
    this.generateAuthenticatorLink(this.previousPage);
  }

  public ngOnDestroy(): void {
    this.secondAuthLvlService.stopCodeRequestTimer();
    unsubscribeAll(this.subscriptions$);
  }

  public subscribeToAuthenticatorSecretChanges(): void {
    this.subscriptions$.push(
      this.secondAuthLvlService.otpAuthenticatorSecret.subscribe((authenticatorSecret: string) => {
        this.authenticatorSecretPart = authenticatorSecret;
        this.authenticatorSecret = `otpauth://totp/1L2C:${this.email}?secret=${authenticatorSecret}&issuer=1L2C`;
      }),
    );
  }

  public generateAuthenticatorLink(previousPage: string): void {
    this.operationInfoService.setupOperation({ spinner: 'global' }, () => {
      this.secondAuthLvlService.generateAuthenticatorSecret(previousPage);
    });
  }

  public returnToPreviousPage(): void {
    promiseWithCatch(
      this.router.navigate([ProjectLinks.LINK_SECOND_AUTH_LEVEL], {
        state: {
          previousPage: this.bindAuthenticator ? this.previousPage : undefined,
          bindAuthenticator: this.bindAuthenticator,
        },
      }),
    );
  }

  private parseNavigationExtras(): void {
    const navigation: MaybeNull<Navigation> = this.router.getCurrentNavigation();
    if (navigation && navigation.extras.state && navigation.extras.state['previousPage']) {
      this.previousPage = navigation.extras.state['previousPage'] as string;
      this.email = navigation.extras.state['email'] as string;
      this.bindAuthenticator = navigation.extras.state['bindAuthenticator'] as boolean;
    } else {
      promiseWithCatch(this.router.navigateByUrl(ProjectLinks.LINK_SECOND_AUTH_LEVEL));
    }
  }
}
